export const NUM_PLAYERS_CHANGED = 'NUM_PLAYERS_CHANGED'

export const numPlayersChanged = ({ numPlayers }) => {
    return { type: NUM_PLAYERS_CHANGED, numPlayers }
}


// WEBPACK FOOTER //
// ./src/reducers/numPlayers/actions.js